import api from 'api'

const destroyCertificate = (certificateId: number) => {
  return api.delete(`/administration/certificates/${certificateId}`)
}

export default destroyCertificate
